import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { unassignedTripList } from "../../../Api/api";

// Define an initial state for the slice
const initialState = {
   data: null,
   loading: false,
   error: null,
};



export const unassignedTripVehiclesAsync=createAsyncThunk(
   "/unassigned-trip-vehicles",
   async ({ done, err }, thunkAPi) => {
      try {
         
         const { data: response } = await unassignedTripList();
         if (response.statusCode === 200) {
            done && done(response.res);
            return thunkAPi.fulfillWithValue(response.res);
         } else {
            throw response;
         }
      } catch (error) {
         // You can customize the error handling here
         
         err && err(error.message);
         return thunkAPi.rejectWithValue(error);
      }
   }

);

const unassignedTripVehiclesSlice = createSlice({
   name: "/unassigned-trip-vehicles",
   initialState,
   reducers: {

   },
   extraReducers: (builder) => {
      builder
         .addCase(unassignedTripVehiclesAsync.pending, (state) => {
            state.loading = true;
            state.error = null;
         })
         .addCase(unassignedTripVehiclesAsync.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            // 
         })
         .addCase(unassignedTripVehiclesAsync.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload; // error message from the rejectWithValue call
         });
   },
});



export default unassignedTripVehiclesSlice.reducer;